import React from "react";
import ComplexText from "@ui/complex-text";
import { IconCross, IconTick, IconWarningCircle } from "../../ui/icons";

const Heading = ({ data }) => {
    if (!data.heading) return null;
    return (
        <h1 className="text-xl md:text-[26px] mb-3 md:mb-5 text-skin-dark font-semibold max-w-lg">
            {data.heading}
        </h1>
    );
};

const Subheading = ({ data }) => {
    if (!data.subheading) return null;
    return (
        <h2 className="md:text-xl mb-2 text-skin-dark font-semibold">
            {data.subheading}
        </h2>
    );
};

const ListItem = ({ item, listType }) => {
    return (
        <li className="flex gap-2 text-sm md:text-base mb-3 last:mb-0">
            {listType === "Ticked" && (
                <IconTick className="md:w-4 md:h-4 w-4 h-4 mt-1" />
            )}
            {listType === "TickedPositive" && (
                <IconTick className="text-[#00B267] md:w-4 md:h-4 w-4 h-4 mt-1" />
            )}
            {listType === "Crossed" && (
                <IconCross className="text-[#C43D3D] md:w-4 md:h-4 w-4 h-4 mt-1" />
            )}
            {listType === "Warning" && (
                <IconWarningCircle className="text-[#C43D3D] md:w-4 md:h-4 w-4 h-4 mt-1" />
            )}
            <ComplexText values={item} />
        </li>
    );
};

const ListItems = ({ items }) => {
    if (!items) return null;
    return (
        <ul>
            {items.map((item, index) => {
                return (
                    <ListItem
                        key={index}
                        item={item.text}
                        listType={item.type}
                    />
                );
            })}
        </ul>
    );
};

const ListTexts = ({ texts, listType }) => {
    if (!texts) return null;
    return (
        <ul className={listType === "Default" ? "list-disc" : ""}>
            {texts.map((item, index) => {
                return <ListItem key={index} item={item} listType={listType} />;
            })}
        </ul>
    );
};

const ListTextsWidget = ({ data }) => {
    if (!data || !(data.texts || data.items)) return null;
    return (
        <>
            <Heading data={data} />
            <Subheading data={data} />
            <ListTexts texts={data.texts} listType={data.listType} />
            <ListItems items={data.items} />
        </>
    );
};

export default ListTextsWidget;
